/* eslint-disable implicit-arrow-linebreak */
import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@folio/stripes-components';
import NavButton from '../../MainNav/NavButton';

function SettingsButton({
  selectedAppName,
  settingsApps,
  navigateByUrl,
  hasPerm,
}) {
  const appSettingsRoutes = Object.assign(
    ...settingsApps.map((app) => ({ [app]: `/${app}` })),
    {
      checkout: '/circulation',
      checkin: '/circulation',
      agreements: '/erm',
      courses: '/cr',
      'erm-usage': '/eusage',
      'erm-comparisons': '/comparisons-erm',
    },
  );

  const hasSetting = Object.keys(appSettingsRoutes).includes(selectedAppName);

  return (
    <NavButton
      aria-label="Settings button"
      data-test-item-help-button
      onClick={() =>
        navigateByUrl({
          route:
            selectedAppName !== undefined
              ? `/settings${appSettingsRoutes[selectedAppName]}`
              : '/settings',
        })
      }
      disabled={!hasPerm && !hasSetting && selectedAppName !== undefined}
      icon={<Icon icon="gear" />}
      id="settings-button"
    />
  );
}

SettingsButton.propTypes = {
  selectedAppName: PropTypes.string,
  settingsApps: PropTypes.arrayOf(PropTypes.string),
  navigateByUrl: PropTypes.func,
  hasPerm: PropTypes.bool,
};

export default SettingsButton;
